import { render, staticRenderFns } from "./DevicesCrud.vue?vue&type=template&id=76864d96&"
import script from "./DevicesCrud.vue?vue&type=script&lang=js&"
export * from "./DevicesCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports